export default function CrystalsInActive({
    width = 22,
    height = 24,
    className,
    style,
    stroke = '#959595',
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 24"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M18.4746 0.841797L21.083 6.22754L17.7002 15.126L11 22.4453L4.29883 15.126L0.916016 6.22754L3.52539 0.841797H18.4746Z"
                stroke={stroke}
                strokeWidth="1.68333"
            />
        </svg>
    );
}
